module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/down_arrow2-40d53ce1e8c4c8d50d005cebe7645c85.svg&quot;;"